<template>
  <header class="header-container">
    <div class="header-content">
      <img src="@/assets/svg/teamstack.svg" alt="TeamStack Logo" class="header-logo" />
    </div>
  </header>
</template>

<style lang="scss" scoped>
.header-container {
  background: #FEF6EB;
}

.header-content {
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  z-index: 1;

  @media screen and (max-width: 768px) {
    padding: 12px 16px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('@/assets/images/noise-bg-hero.png');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100%;
    z-index: 0;
  }
}

.header-logo {
  height: 45px;
  width: auto;

  @media screen and (max-width: 768px) {
    height: 35px;
  }
}
</style>